import { getToken } from '@helpscout/hsds-tokens/getToken'
import styled from 'styled-components'

import { variableFontSize } from 'hsds/utils/fonts'
import { generateLinkStyles } from 'hsds/utils/mixins'

export const VAR_NAMESPACE_SIZE = 'HSDSGlobalTextFontSize'

export const TextUI = styled.span`
  --hsds-text-color: ${getToken('text.color.default')};
  --hsds-text-font-weight: 400;

  color: var(--hsds-text-color);
  font-weight: var(--hsds-text-font-weight);
  line-height: 1.5;

  &.is-disableSelect {
    user-select: none;
  }

  &.is-10 {
    ${variableFontSize({
      varName: VAR_NAMESPACE_SIZE,
      fontSize: 10,
    })}
  }

  &.is-11 {
    ${variableFontSize({
      varName: VAR_NAMESPACE_SIZE,
      fontSize: 11,
    })}
  }

  &.is-12 {
    ${variableFontSize({
      varName: VAR_NAMESPACE_SIZE,
      fontSize: 12,
    })}
  }

  &.is-13 {
    ${variableFontSize({
      varName: VAR_NAMESPACE_SIZE,
      fontSize: 13,
    })}
  }

  &.is-14 {
    ${variableFontSize({
      varName: VAR_NAMESPACE_SIZE,
      fontSize: 14,
    })}
  }

  &.is-15 {
    ${variableFontSize({
      varName: VAR_NAMESPACE_SIZE,
      fontSize: 15,
    })}
  }

  &.is-16 {
    ${variableFontSize({
      varName: VAR_NAMESPACE_SIZE,
      fontSize: 16,
    })}
  }

  &.is-20 {
    ${variableFontSize({
      varName: VAR_NAMESPACE_SIZE,
      fontSize: 20,
    })}
  }

  &.is-48 {
    ${variableFontSize({
      varName: VAR_NAMESPACE_SIZE,
      fontSize: 48,
    })}
  }

  &.is-error {
    --hsds-text-color: ${getToken('text.color.error')};
  }

  &.is-success {
    --hsds-text-color: ${getToken('text.color.success')};
  }

  &.is-warning {
    --hsds-text-color: ${getToken('text.color.warning')};
  }

  &.is-100 {
    --hsds-text-font-weight: 100;
  }

  &.is-200 {
    --hsds-text-font-weight: 200;
  }

  &.is-300 {
    --hsds-text-font-weight: 300;
  }

  &.is-400 {
    --hsds-text-font-weight: 400;
  }

  &.is-500 {
    --hsds-text-font-weight: 500;
  }

  &.is-600 {
    --hsds-text-font-weight: 600;
  }

  &.is-700 {
    --hsds-text-font-weight: 700;
  }

  &.is-800 {
    --hsds-text-font-weight: 800;
  }

  &.is-900 {
    --hsds-text-font-weight: 900;
  }

  &.is-shade-default {
    --hsds-text-color: ${getToken('text.color.default')};
  }

  &.is-shade-dark {
    --hsds-text-color: ${getToken('color.text.dark')};
  }

  &.is-shade-subtle {
    --hsds-text-color: ${getToken('text.color.subtle')};
  }

  &.is-shade-light {
    --hsds-text-color: ${getToken('text.color.light')};
  }

  &.is-shade-slightlyMuted {
    --hsds-text-color: ${getToken('text.color.slightlyMuted')};
  }

  &.is-shade-muted {
    --hsds-text-color: ${getToken('text.color.muted')};
  }

  &.is-shade-faint {
    --hsds-text-color: ${getToken('text.color.faint')};
  }

  &.is-shade-extraMuted {
    --hsds-text-color: ${getToken('text.color.extraMuted')};
  }

  &.is-truncate {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.is-wordWrap {
    word-break: break-word;
  }

  &.is-no-wrap {
    white-space: nowrap;
  }

  &.is-lineHeightInherit {
    line-height: inherit;
  }

  &.is-lineHeightReset {
    line-height: 1;
  }

  &.is-all-caps {
    letter-spacing: 0.4px;
    text-transform: uppercase;
  }

  &.is-block {
    display: block;
  }

  &.is-center {
    text-align: center;
  }

  &.is-linkStyle {
    ${generateLinkStyles()}
    border: none;
    background: none;
    display: inline-block;
  }

  &.is-noUnderline {
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }

  &.is-plainLink {
    --hsds-text-color: ${getToken('text.color.link')};
  }

  &.is-samp {
    font-family: var(--HSDSGlobalFontFamilyMono);
  }
`
